import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { USER_PROFILE_PATH, WHATSAPP_SUPPORT_URL } from "../../Util/constant";
import { useProfileContext } from "../context/ProfileContext";
import { getFirstLetterCapitalized } from "../../Util/helper_functions";
import ResetpasswordModal from "../components/modal/ResetPasswordModal";
import { useNavigate } from "react-router-dom";
import { getTruncatedText } from "../user-pages/ui-helper";
import { STORAGE_KEYS } from "../../Util/key_helper";
const SidebarProfile = () => {
  const { profileData, profileLoading } = useProfileContext();
  const [selectedImage, setSelectedImage] = useState("");
  const [dropDirection, setDropDirection] = useState("end");
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (!profileLoading && profileData?.user_id) {
      const imageUrl = `${USER_PROFILE_PATH}${profileData?.user_id}.jpg?${new Date().getTime()}`;
      fetch(imageUrl, { method: "HEAD" })
        .then((res) => {
          if (res.ok) {
            setSelectedImage(imageUrl);
          } else {
            setSelectedImage(null);
          }
        })
        .catch(() => {
          setSelectedImage(null);
        });
    }
  }, [profileData, profileLoading]);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 991) {
        setDropDirection("up");
      } else {
        setDropDirection("end");
      }
    };
    handleResize(); // Set initial value
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const handleLogout = () => {
    localStorage.removeItem(STORAGE_KEYS.FX_USER_REMEMBER_ME());
    localStorage.removeItem(STORAGE_KEYS.FX_USER_ACCESS_TOKEN);
    navigate("/login");
  }
  return (
    <>
      <div className={` p-3 mt-auto mb-2 `}>
        <a
          href={WHATSAPP_SUPPORT_URL} // Replace with your real number
          target="_blank"
          rel="noopener noreferrer"
          className="support-badge"
          style={{ textDecoration: 'none' }}
        >
          <i className="mdi mdi-whatsapp  "></i>
          <span className="sidebar-support-text font-medium  ms-2">Support</span>
        </a>
      </div>
      <div className={`sidebar-profile-section p-3 mt-auto `}>
        <Dropdown align="end" drop={dropDirection}>
          <Dropdown.Toggle as="button" className="d-flex align-items-center  text-color no-caret justify-content-between w-100 sidebar-profile-toggle" style={{ background: 'none', border: 'none', padding: 0, width: '100%' }}>
            <div className="d-flex align-items-center">
              {selectedImage ? (
                <img
                  src={selectedImage}
                  alt="Profile"
                  className="sidebar-profile-img"
                />
              ) : (
                <div className="sidebar-profile-letter">
                  {getFirstLetterCapitalized(profileData?.actual_email)}
                </div>
              )}
              {/* Hide this on mobile */}
              <div className="ms-2 sidebar-profile-name-wrapper">
                <h6 className="mb-0 sidebar-profile-name text-color">
                  {getTruncatedText(profileData?.actual_email, 15, 'mb-0 me-2', 'h6')}

                </h6>
              </div>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu className="sidebar-profile-dropdown">
            <Dropdown.Item onClick={() => navigate('/profile')} className="d-flex align-items-center">
              <div className="dropdown-icon">
                <i className="mdi mdi-account-circle info-text"></i>
              </div>
              <span className="ms-2">My Profile</span>
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => setShowResetPasswordModal(true)} className="d-flex align-items-center">
              <div className="dropdown-icon">
                <i className="mdi mdi-key-change warning-text"></i>
              </div>
              <span className="ms-2">Reset Password</span>
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={handleLogout} className="d-flex align-items-center">
              <div className="dropdown-icon">
                <i className="mdi mdi-logout danger-text"></i>
              </div>
              <span className="ms-2">Log Out</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown >
        {showResetPasswordModal && (
          <ResetpasswordModal
            show={showResetPasswordModal}
            onClose={() => setShowResetPasswordModal(false)}
          />
        )
        }
      </div >
    </>
  );
};

export default SidebarProfile;
